import { User } from '../../Model/dbo/User';
import { useEffect, useState } from "react";
import axios from 'axios';
import Cookies from 'universal-cookie';
import { BaseApi } from './BaseUrl'
import { Index } from '../../Model/dbo/Index';





export async function GetUnitIndex(): Promise<Array<Index>> {
    try {
        var user= new Cookies().get('user');
        const requestOptions = {
          headers: { 'Authorization':user.Token}};

        const response = await axios.get(BaseApi+'HR/GetUnitIndex',requestOptions);
        return response.data;
    }
    catch (error) {
        console.error(error);
        return []; // اگر خطایی رخ دهد، یک آرایه خالی برگردانده می‌شود
    }
}

export async function GetUnitIndexValue(): Promise<Array<any>> {
    try {
        var user= new Cookies().get('user');
        const response = await axios.get(BaseApi+"HR/GetUnitIndexValue?token=" + user.Token);
        return response.data;
    }
    catch (error) {
        console.error(error);
        return []; // اگر خطایی رخ دهد، یک آرایه خالی برگردانده می‌شود
    }
}